import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
  selector: "lib-json-edit-type",
  standalone: false,
  templateUrl: "./json-edit-type.component.html",
  styleUrls: ["./json-edit-type.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JsonEditTypeComponent extends FieldType<FieldTypeConfig> {}
